import { FlagsPermissionCodBalance } from "@/feature-flags/flags-permission-cod-balance";
import { RouterView } from "vue-router";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const CodIncome = () =>
  import(
    /* webpackChunkName: "CodIncome" */ "@/app/ui/views/cod-income/index.vue"
  );
const CodWithdraw = () =>
  import(
    /* webpackChunkName: "Balance" */ "@/app/ui/views/cod-income/components/cod-income-withdrawal.vue"
  );

export default [
  {
    path: "/cod-income",
    component: Layout,
    name: "cod-income",
    redirect: "/cod-income",
    meta: {
      icon: "empty",
      children: false,
      title: "Penghasilan COD",
      name: "Penghasilan COD",
      customName: "codIncome.summaryTitle",
      hidden: true,
      isFreeze: true,
      permission: FlagsPermissionCodBalance.permission_cod_balance_enable
    },
    children: [
      {
        path: "/cod-income",
        name: "cod-income",
        component: CodIncome,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/cod-income",
    component: Layout,
    name: "cod-income-withdraw-wrapper",
    meta: {
      header: true,
      hidden: true,
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
      permission: FlagsPermissionCodBalance.permission_cod_balance_enable
    },
    children: [
      {
        path: "",
        component: RouterView,
        name: "cod-income-group",
        meta: {
          parent: "codIncome.summaryTitle",
          "parent-path": "/cod-income"
        },
        children: [
          {
            path: "withdraw",
            name: "cod-income-withdraw",
            component: CodWithdraw,
            meta: {
              header: true,
              customPath: true,
              title: "Penarikan",
              name: "Penarikan",
              isAuth: true,
              permission:
                FlagsPermissionCodBalance.permission_cod_balance_enable
            }
          }
        ]
      }
    ]
  }
];
